// frontend\src\api\api.js
import axios from "axios";

const getToken = () => {
  const authTokensString = localStorage.getItem("access_token");
  if (authTokensString) {
    try {
      return JSON.parse(authTokensString);
    } catch (e) {
      console.error("Error parsing authTokens:", e);
      return null;
    }
  }
  return null;
};

const api = axios.create({
  baseURL: "/api",
});

api.interceptors.request.use(
  (config) => {
    const token = getToken();
  
    
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token.access}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.defaults.withCredentials = true;

api.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    
    // Пропускаем обработку ошибок для страницы входа и запросов без токена
    if (error.config.url.includes('/token/') || !getToken()) {
      console.log(error);
      
      return Promise.reject(error);
    }

    if (error.response?.status === 401 && originalRequest && !originalRequest._isRetry) {
      originalRequest._isRetry = true;
      try {
        const response = await axios.post(
          `/api/token/refresh/`,
          {},
          { withCredentials: true }
        );
        const authTokens = response.data;
    
        
        localStorage.setItem("access_token", JSON.stringify(authTokens));
        return api(originalRequest);
      } catch (refreshError) {
        console.log("Сессия истекла. Перенаправление на страницу входа...");
        localStorage.removeItem("access_token");
        localStorage.removeItem("username");
        localStorage.removeItem("isSuperuser");
        
        // Если мы уже не на странице входа, перенаправляем
        if (!window.location.pathname.includes('/login')) {
          window.location.href = '/login?session_expired=true';
        }
        return Promise.reject(refreshError);
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;